const MONTHLY_YEARLY_UPGRADE_PLAN_MAP = {
  'pro-monthly': 'pro-yearly',
  'essential-monthly': 'essential-yearly',
}

// Monthly→yearly upgrade discount experiment (follow-up to PR #4240).
// PR #4240 hardcoded Ver C ("...only {amount}/month") as the winning control.
// This experiment pits that winning control against two discount arms.
// Control (no variant / `control`) keeps the exact #4240 behaviour untouched.
// Discount arms: discountPercentage is configured on Unleash (variant payload),
// not declared here. The frontend reads it from the variant payload and falls back
// to extracting it from the variant name (`discount-20pct` → 20) when no payload
// is set. The backend derives the Stripe coupon (GOYEARLY{N}) from the percentage.
const MONTHLY_TO_YEARLY_DISCOUNT_EXPERIMENT_FLAG = 'AHA-40735-abtest-discount-coupon'

// Discount percentage applied to the monthly→yearly upgrade when no discount arm
// is active (Control / flag off). This is the winning #4240 deal made permanent.
const DEFAULT_MONTHLY_TO_YEARLY_DISCOUNT_PERCENTAGE = 40

// Known variant name prefixes — a variant is a discount arm when its name starts
// with `discount-`. This keeps the gate logic explicit without hardcoding percentages.
const DISCOUNT_VARIANT_NAME_PREFIX = 'discount-'

// Monthly-cancel retention experiment: when a monthly subscriber tries to cancel,
// offer them a deep-discounted switch to yearly ("pay ~3 months, keep a full year")
// instead of the legacy 1-free-month offer. This is a variant experiment — only the
// `yearly-offer` treatment arm shows the new modal; control / any other arm / flag off
// keeps the legacy flow unchanged.
const MONTHLY_CANCEL_YEARLY_OFFER_FLAG = 'AHA-37484-cancellation-offer'
const CANCELLATION_OFFER_TREATMENT_VARIANT = 'yearly-offer'

// Sent to /yearly-upgrade-preview so the backend applies the retention coupon
// (a fixed 60% off the yearly list price, coupon GOYEARLY60) instead of the upsell
// discount. Absence of this context preserves the existing upsell behaviour.
const YEARLY_RETENTION_OFFER_CONTEXT = 'cancel-retention'

export {
  MONTHLY_YEARLY_UPGRADE_PLAN_MAP,
  MONTHLY_TO_YEARLY_DISCOUNT_EXPERIMENT_FLAG,
  DEFAULT_MONTHLY_TO_YEARLY_DISCOUNT_PERCENTAGE,
  DISCOUNT_VARIANT_NAME_PREFIX,
  MONTHLY_CANCEL_YEARLY_OFFER_FLAG,
  CANCELLATION_OFFER_TREATMENT_VARIANT,
  YEARLY_RETENTION_OFFER_CONTEXT,
}
